<template>
  <div>
    <h1 class="main-header" v-translate translate-context="roles">Create New Role</h1>
    
    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton color="primary" @click="onClickSave" v-translate translate-context="form">Create</CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <Form ref="role_form" :data="empty" @save="onSave" :save_text="$pgettext('form','Create')"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import Form from "@/domain/roles/components/Form.vue";
import {SuccessNotification} from "@/domain/core/exception/exceptions";

export default {
  name: 'NewRole',
  components: {Form},
  data() {
    return {
      empty: {
        name: '',
        permissions: {},
        visible_by: [],
        description: {},
        public_name: {},
        code: '',
      }
    }
  },
  methods: {
    ...mapActions('roles', [
      'createRole',
    ]),
    async onSave(data) {
      await this.createRole(data)
      await this.$router.push({name: 'roles.list'})
      throw new SuccessNotification(this.$pgettext('roles', 'Role created!'))
    },
    onClickSave() {
      this.$refs.role_form.onSave()
    }
  }
}
</script>

<style scoped>

</style>